<template>
  <div class="ma3 ma4-l mb4">
    <details-section class="mt4">
      <template #header>
        Реквизиты
      </template>
      <template #content>
        <!--
        тут, возможно, нужен цикл по полям стейта, но перед этим надо сформировать их порядок в беке
        -->
        <live-field :field="state.title" :save="updateState" #default="{ field, update, saving }">
          <component :is="field.type" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving"/>
        </live-field>
        <live-field :field="state.number" :save="updateState" #default="{ field, update, saving }">
          <component :is="field.type" :field="field"  @input="update($event)" :template="fieldTemplate" :saving="saving"/>
        </live-field>
        <live-field :field="state.tender_id" :save="updateState" #default="{ field, update, saving }">
          <reference-field :entity="entity" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving" />
        </live-field>
        <live-field :field="state.counteragent_company_id" :save="updateState" #default="{ field, update, saving }">
          <reference-field :entity="entity" :state="state" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving" />
        </live-field>
        <live-field :field="state.counteragent_user_id" :save="updateState" #default="{ field, update, saving }">
          <reference-field :entity="entity" :state="state" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving" />
        </live-field>

        <live-field :field="state.start_at" :save="updateState" #default="{ field, update, saving }">
          <component :is="field.type" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving"/>
        </live-field>
        <live-field :field="state.close_at" :save="updateState" #default="{ field, update, saving }">
          <component :is="field.type" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving"/>
        </live-field>
        <live-field :field="state.archive_at" :save="updateState" #default="{ field, update, saving }">
          <component :is="field.type" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving"/>
        </live-field>
        <live-field :field="state.auto_archive" :save="updateState" #default="{ field, update, saving }">
          <component :is="field.type" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving"/>
        </live-field>
        <live-field :field="state.archive_after_days" :save="updateState" #default="{ field, update, saving }">
          <component :is="field.type" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving"/>
        </live-field>
        <live-field :field="state.reject_reason" :save="updateState" #default="{ field, update, saving }">
          <component :is="field.type" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving"/>
        </live-field>
        <live-field :field="state.has_real_contract" :save="updateState" #default="{ field, update, saving }">
          <component :is="field.type" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving"/>
        </live-field>
        <live-field :field="state.need_agreement" :save="updateState" #default="{ field, update, saving }">
          <component :is="field.type" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving"/>
        </live-field>
      </template>
    </details-section>

    <details-section class="mt4">
      <template #header>
        Позиции
      </template>
      <template #content>
        <live-field :field="state.delivery_address" :save="updateState" #default="{ field, update, saving }">
          <text-field :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving"/>
        </live-field>
        <live-field :field="state.vat" :save="updateState" #default="{ field, update, saving }">
          <component :is="field.type" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving"/>
        </live-field>
        <live-field :field="state.currency_id" :save="updateState" #default="{ field, update, saving }">
          <reference-field :entity="entity" :state="state" :field="field" @input="update($event)" :template="fieldTemplate" :saving="saving" />
        </live-field>

        <positions-section
          :id='id'
          :out="out"
          :state="state"
          :actors="actors"
          class="bg-white mt4"
        />
      </template>
    </details-section>
    <input type="file" ref="fileInput" accept=".xlsx" class="clip" />
  </div>
</template>

<script>
import DetailsSection from '@/components/common/CardDetailsSection.vue'

// можно использовать разные темплейты для UI организации полей ввода
import Horizontal from '@/components/common/form/templates/Horizontal.vue'
import Vertical from '@/components/common/form/templates/Vertical.vue'

import LiveField from '@/components/common/form/LiveField.vue'
import IntegerField from '@/components/common/form/scalar/IntegerField.vue'
import StringField from '@/components/common/form/scalar/StringField.vue'
import TextField from '@/components/common/form/scalar/TextField.vue'
import BooleanField from '@/components/common/form/scalar/BooleanField.vue'
import DatetimeField from '@/components/common/form/scalar/DatetimeField.vue'
import DecimalField from '@/components/common/form/scalar/DecimalField.vue'
import ReferenceField from '@/components/common/form/ReferenceField.vue'
import PositionsSection from '@/components/common/PositionsSection.vue'
import { DataService } from '@/services/DataService.js'
import { download } from '@/utils/download'
import { pluralForm } from '@/utils/pluralForms'
import fileReader from '@/composables/fileReader'

export default {
  props: ['id', 'out', 'state', 'updateState'],
  components: {
    DetailsSection,
    Horizontal,
    Vertical,
    LiveField,
    IntegerField,
    StringField,
    TextField,
    BooleanField,
    DatetimeField,
    DecimalField,
    ReferenceField,
    PositionsSection
  },
  setup (props) {
    const { bindFileInput, selectFile } = fileReader()
    return {
      bindFileInput,
      selectFile
    }
  },
  mounted () {
    this.bindFileInput(this.$refs.fileInput)
  },
  computed: {
    loadPositionsParams () {
      return {
        filter: { contract_id: this.id }
      }
    }
  },
  data () {
    return {
      fieldTemplate: Horizontal, // Vertical
      entity: { id: this.id, name: 'contract' },
      showModal: true,
      actors: {
        loadPositions: {
          title: 'Загрузить позиции',
          enabled: (actions, positions) => true,
          callback: async (params) => {
            const p = { ...params, filter: { ...params.filter, contract_id: this.id } }
            return DataService.getContractPositions(p)
          }
        },
        appendParentPositions: {
          title: 'Импорт из конкурса',
          enabled: (actions, positions) => {
            return actions &&
              actions.create &&
              this.state.tender_id.value &&
              this.state.counteragent_company_id.value
          },
          callback: async () => {
            const params = {
              contract_id: this.id,
              tender_id: this.state.tender_id.value,
              company_id: this.state.counteragent_company_id.value
            }
            return DataService.appendTenderWinnerPositions(params)
          }
        },
        loadPositionsFromFile: {
          title: 'Импорт из файла',
          enabled: (actions, positions) => {
            return actions && actions.create
          },
          callback: async (psComponent) => {
            return this.selectFile(({ file, name }) => {
              const params = {
                contract_id: this.id,
                file: file,
                name: name
              }
              psComponent.anOperationInProgress = true
              return DataService.importContractPositions(params)
                .then(({ positions }) => {
                  const count = (positions || []).length
                  const posTitle = pluralForm(count, ['позиция', 'позиции', 'позиций'])
                  this.$store.dispatch('notification/add', {
                    title: `Импортированно ${count} ${posTitle}`,
                    type: 'info'
                  })
                  return positions
                })
                .finally(() => {
                  psComponent.anOperationInProgress = false
                  psComponent.reloadPositionsPage() // криво но пока так...
                })
            })
          }
        },
        downloadTemplate: {
          title: 'Шаблон файла',
          enabled: (actions, positions) => {
            return actions && actions.create
          },
          callback: async () => {
            return DataService.fileTemplate({ name: 'CONTRACT_POSITIONS' })
              .then(({ data, name }) => download(data, name))
              .catch(err => {
                console.error(err)
                this.error = 'Произошла ошибка'
              })
          }
        },
        removeSelectedPositions: {
          title: 'Удалить выделенные',
          enabled: (actions, selected) => {
            return actions && actions.delete && selected && selected.size > 0
          },
          callback: async (psComponent) => {
            const params = { contract_id: this.id, positions: Array.from(psComponent.selected) }
            return DataService.removeContractPositions(params)
          }
        },
        removeAllPositions: {
          title: 'Удалить все',
          enabled: (actions, positions) => {
            return actions && actions.delete && positions && positions.length > 0
          },
          callback: async () => {
            const params = { contract_id: this.id }
            return DataService.removeContractPositions(params)
          }
        },
        createPosition: {
          title: null,
          enabled: (actions, positions) => true,
          makeDraft: ({ id, name }) => {
            return {
              id: null,
              position_id: id,
              title: name,
              anno: null,
              amount: null,
              unit_id: null,
              price: null,
              vat: null,
              currency_id: null,
              delivery_within_days: null,
              vendor_code: null
            }
          },
          callback: async (position) => {
            delete position.__typename
            delete position.id
            const params = { contract_id: this.id, input: position }
            return DataService.createContractPosition(params)
              .then(({ data: { create_contract_position: { position, errors } } }) => {
                return { position, errors }
              })
          }
        },
        updatePosition: {
          title: null,
          enabled: (actions, positions) => true,
          callback: async (position) => {
            const positionId = position.id
            delete position.__typename
            delete position.id
            const params = { position_id: positionId, input: position }
            return DataService.updateContractPosition(params)
              .then(({ data: { update_contract_position: { position, errors } } }) => {
                return { position, errors }
              })
          }
        },
        deletePosition: {
          title: null,
          enabled: (actions, positions) => true,
          callback: ({ id }) => {
            const params = { contract_id: this.id, positions: [id] }
            return DataService.removeContractPositions(params)
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
